import { Link } from 'react-router-dom';
import { rankedOutcomes } from '@cerebro-diem/core';
import { errorMessage } from '../../services/errors';
import { useOutcomes } from '../../services/outcomes';

/**
 * The weekly review's step for the list of what matters most (CER-179): it
 * shows the list as it stands and asks whether it is still right, with the
 * way to change it. Shown with the newest weekly review.
 */
export default function OutcomesCheck() {
  const query = useOutcomes();
  if (query.isPending) return null;
  if (query.isError) return <p className="text-sm text-error">Could not load your outcomes: {errorMessage(query.error)}</p>;
  const ranked = rankedOutcomes(query.data);
  return (
    <section aria-label="What matters most" className="mt-4 rounded-xl border border-primary/30 bg-primary/5 p-4 text-sm space-y-2">
      {ranked.length === 0 ? (
        <p className="font-medium">You have not said what matters most yet.</p>
      ) : (
        <>
          <p className="font-medium">Is this still what matters most, in this order?</p>
          <ol className="list-decimal pl-5 space-y-0.5">
            {ranked.map((outcome) => (
              <li key={outcome.id}>{outcome.title}</li>
            ))}
          </ol>
        </>
      )}
      <Link to="/outcomes" className="inline-block font-medium underline">
        {ranked.length === 0 ? 'Make the list' : 'Change the list'}
      </Link>
    </section>
  );
}
